import React, { useEffect, useState } from "react";
import AdminPageLayout from "../components/AdminPageLayout";
import "../components/AdminPageLayout.css";
import "./adminAccountDeletion.css";
import {
  fetchScheduledDeletionRequests,
  fetchPendingDeletionRequests,
  deleteAccountNow,
  cancelDeletionRequest,
} from "./adminAccountDeletionService";

const STATUS_BADGE = {
  PENDING_OTP:  "adm-badge-amber",
  SCHEDULED:    "adm-badge-blue",
  DELETED:      "adm-badge-red",
  CANCELLED:    "adm-badge-gray",
  FAILED:       "adm-badge-red",
};

const AdminAccountDeletionPage = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPendingOnly, setShowPendingOnly] = useState(false);
  const [actionLoadingId, setActionLoadingId] = useState(null);

  useEffect(() => { loadRequests(showPendingOnly); }, [showPendingOnly]);

  const loadRequests = async (pendingOnly = false) => {
    setLoading(true);
    const res = pendingOnly ? await fetchPendingDeletionRequests() : await fetchScheduledDeletionRequests();
    if (res.status === 200) setRequests(res.data || []);
    else { alert(res.message || "Failed to load deletion requests"); setRequests([]); }
    setLoading(false);
  };

  const handleDeleteNow = async (requestId, name) => {
    if (!window.confirm(`Permanently delete account for ${name}?`)) return;
    const adminNote = window.prompt("Enter admin note (optional):", "") || "";
    setActionLoadingId(requestId);
    const res = await deleteAccountNow(requestId, adminNote);
    if (res.status === 200) { alert(res.message || "Account deleted successfully"); loadRequests(showPendingOnly); }
    else alert(res.message || "Failed to delete account");
    setActionLoadingId(null);
  };

  const handleCancel = async (requestId, name) => {
    if (!window.confirm(`Cancel deletion request for ${name}?`)) return;
    const adminNote = window.prompt("Enter admin note (optional):", "") || "";
    setActionLoadingId(requestId);
    const res = await cancelDeletionRequest(requestId, adminNote);
    if (res.status === 200) { alert(res.message || "Deletion request cancelled"); loadRequests(showPendingOnly); }
    else alert(res.message || "Failed to cancel deletion request");
    setActionLoadingId(null);
  };

  const fmt = (v) => v ? new Date(v).toLocaleString() : "—";

  return (
    <AdminPageLayout
      title="Account Deletion Requests"
      subtitle="Review and action user-submitted account deletion requests."
      instruction="Users who request account deletion go through an OTP verification step. Requests in SCHEDULED status will be auto-deleted after the grace period. Use 'Delete Now' to immediately remove the account, or 'Cancel' to abort the request and notify the user."
      actions={
        <div style={{ display: "flex", gap: 8 }}>
          <button className="adm-btn adm-btn-ghost" onClick={() => setShowPendingOnly(!showPendingOnly)}>
            {showPendingOnly ? "Show All" : "Pending Only"}
          </button>
          <button className="adm-btn adm-btn-ghost" onClick={() => loadRequests(showPendingOnly)}>
            ↻ Refresh
          </button>
        </div>
      }
    >
      {loading ? (
        <p className="adm-loading">Loading deletion requests…</p>
      ) : (
        <div className="adm-table-wrap">
          <table className="adm-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>Requested At</th>
                <th>Scheduled Deletion</th>
                <th>Admin Note</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {requests.length === 0 ? (
                <tr><td colSpan="7" className="adm-empty">No deletion requests found</td></tr>
              ) : (
                requests.map((r) => (
                  <tr key={r.requestId}>
                    <td style={{ fontWeight: 500 }}>{r.name || "—"}</td>
                    <td>{r.email || "—"}</td>
                    <td>
                      <span className={`adm-badge ${STATUS_BADGE[r.status] || "adm-badge-gray"}`}>
                        {r.status}
                      </span>
                    </td>
                    <td style={{ fontSize: "0.8rem", color: "#64748b" }}>{fmt(r.requestedAt)}</td>
                    <td style={{ fontSize: "0.8rem", color: "#64748b" }}>{fmt(r.scheduledDeletionAt)}</td>
                    <td style={{ color: "#64748b" }}>{r.adminNote || "—"}</td>
                    <td>
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                        <button
                          className="adm-btn adm-btn-danger adm-btn-sm"
                          onClick={() => handleDeleteNow(r.requestId, r.name)}
                          disabled={actionLoadingId === r.requestId || r.status === "DELETED"}
                        >
                          {actionLoadingId === r.requestId ? "…" : "Delete Now"}
                        </button>
                        <button
                          className="adm-btn adm-btn-ghost adm-btn-sm"
                          onClick={() => handleCancel(r.requestId, r.name)}
                          disabled={actionLoadingId === r.requestId || r.status === "DELETED" || r.status === "CANCELLED"}
                        >
                          Cancel
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </AdminPageLayout>
  );
};

export default AdminAccountDeletionPage;
